import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { CompanyProvider } from "@/lib/company";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ChecksPage from "@/pages/ChecksPage";
import TransactionsPage from "@/pages/TransactionsPage";
import BanksPage from "@/pages/BanksPage";
import LoansPage from "@/pages/LoansPage";
import CalendarPage from "@/pages/CalendarPage";
import ProfilePage from "@/pages/ProfilePage";
import { Toaster } from "@/components/ui/sonner";

const Protected = ({ children }) => (
  <ProtectedRoute>
    <CompanyProvider>
      <AppLayout>{children}</AppLayout>
    </CompanyProvider>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/cekler" element={<Protected><ChecksPage /></Protected>} />
            <Route path="/alacaklar" element={<Protected><TransactionsPage /></Protected>} />
            <Route path="/bankalar" element={<Protected><BanksPage /></Protected>} />
            <Route path="/krediler" element={<Protected><LoansPage /></Protected>} />
            <Route path="/takvim" element={<Protected><CalendarPage /></Protected>} />
            <Route path="/profil" element={<Protected><ProfilePage /></Protected>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
